import { render, staticRenderFns } from "./ExpenseDetailFooter.vue?vue&type=template&id=47859f7a&"
import script from "./ExpenseDetailFooter.vue?vue&type=script&lang=js&"
export * from "./ExpenseDetailFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports